// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".fixed[data-v-548ab756]{position:fixed;right:0;z-index:5}.fixed[data-v-548ab756],.sticky[data-v-548ab756]{height:calc(100vh - 60px)!important;top:60px}.sticky[data-v-548ab756]{position:sticky}.arrow[data-v-548ab756]{transition:transform .2s ease;transform:rotate(0deg)}.arrow.opened[data-v-548ab756]{transform:rotate(180deg)}", ""]);
// Exports
module.exports = exports;
